import store from "../store";
import {
  getCurrentWizardNavItems,
  getFeatureGroupFromWizardGroup,
  getWizardMissingKey, shouldUseNewWizardFeaturesRequestsLogic
} from "../bvcomponents/look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {checkIfLookFeaturesReceived, getAdditionalFeaturesOnScroll, getFeaturesPageSize} from "../api/look-api";
import Config from "../config";
import {getBvFeatures, getBvGroupFeatures} from "../api/server-api";
import {setWizardMissingFeatures} from "../actions/wizardFunctions";

export const getAllWizardFeatures = async (layout) => {
  const {wizardState, filterState} = store.getState();
  const {wizardList, wizardMissingFeatures} = wizardState;
  const {filterGroups} = filterState;
  if (!wizardList.length) {
    return
  }
  let missingSharedFeatureNames = [];
  let missingGroups = {}; // {wizardKey: "groupName"}
  for (const wizardItem of wizardList) {
    for (const wizardGroup of wizardItem.wizardGroups) {
      const missingKey = getWizardMissingKey(wizardItem, wizardGroup);
      const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup, layout);
      if (featureGroup && !featureGroup.allFeaturesReceived) {
        await checkIfLookFeaturesReceived(featureGroup, false);
      }
      if (featureGroup && shouldUseNewWizardFeaturesRequestsLogic(wizardGroup, featureGroup)
        && !wizardMissingFeatures[missingKey]) {
        const currentNavItems = getCurrentWizardNavItems(
          {},
          0,
          wizardItem,
          wizardGroup,
          featureGroup,
          filterGroups,
          "",
          []
        );
        (wizardGroup.featuresIncluded || []).forEach(feature => {
          if (currentNavItems.some(navItem => navItem.part.getLowerCasedSharedFeatureName() === feature.sharedFeatureName)) {
            return false
          }
          // if (!missingSharedFeatureNames[wizardGroup.groupName]) {
          //   missingSharedFeatureNames[wizardGroup.groupName] = [];
          // }
          // if (!missingSharedFeatureNames[wizardGroup.groupName].includes(feature.sharedFeatureName)) {
          //   missingSharedFeatureNames[wizardGroup.groupName].push(feature.sharedFeatureName);
          // }
          if (!missingGroups[missingKey]) {
            missingGroups[missingKey] = wizardGroup.groupName;
          }
          if (!missingSharedFeatureNames.includes(feature.sharedFeatureName)) {
            missingSharedFeatureNames.push(feature.sharedFeatureName);
          }
        });
      }
    }
  }
  if (Config.isDevMode()) {
    console.log("Now we will request all missing wizard features", missingGroups, missingSharedFeatureNames);
  }
  if (missingSharedFeatureNames.length) {
    const missingGroupNames = [...new Set(Object.values(missingGroups))];
    const missingSkusResponse = await getBvFeatures(null, missingSharedFeatureNames, true, null, "", null, missingGroupNames);
    if (Config.isDevMode()) {
      console.log("All missing wizard features received", missingSkusResponse);
    }
    if (missingSkusResponse && missingSkusResponse.data) {
      layout.loadNewFeatures(missingSkusResponse.data);
    }
    Object.keys(missingGroups).forEach(missingKey => {
      store.dispatch(setWizardMissingFeatures(missingKey, [])); // prevent requesting again
    })
  }
  return true
}

export const getAllQuotingToolFeatures = async (layout) => {
  const qtCategories = layout.qtCategories;
  if (!qtCategories) {
    return
  }
  for (const qtCategory of qtCategories) {
    for (const subPart of qtCategory.subParts) {
      const featureGroup = subPart.part;

      while (!featureGroup.getRealFeaturesReceivedProperty()) {
        await getAdditionalFeaturesOnScroll(featureGroup); // will continioulsy loop and not wait for the await
        if (layout.isNewLayout) {
          await getAdditionalFeaturesOnScroll(featureGroup);
        } else {
          const shouldContinue = () => {
            if (featureGroup.getRealFeaturesReceivedProperty()) {
              return false
            }
            const pageSize = getFeaturesPageSize(featureGroup);
            return pageSize < 3
          }
          while (shouldContinue()) {
            const layoutAbbr = layout.getCurrentLayoutAbbreviation();
            const nextFeaturesPage = featureGroup.getNextPageToLoad(layoutAbbr);
            featureGroup.requestInProgress = true;
            const response = await getBvGroupFeatures(featureGroup.dbName || featureGroup.partName, nextFeaturesPage, pageSize);
            const responseArray = Array.isArray(response) ? response : [];
            featureGroup.requestInProgress = false;
            featureGroup.setGroupFeatures(responseArray, pageSize, true, layoutAbbr, nextFeaturesPage);
          }
        }
      }
    }
  }
}
